import { render, staticRenderFns } from "./LanguageForm.vue?vue&type=template&id=896c86a4&"
import script from "./LanguageForm.vue?vue&type=script&lang=ts&"
export * from "./LanguageForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports